import { AmountDisplay, VestingInfo } from '@brickken/web3';
import { IVestingCardRowInfoProps } from './VestingCardRowInfo';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

export const getVestingRowDataList = (
  vestingInfo?: VestingInfo
): IVestingCardRowInfoProps[] => {
  const dateFormat = 'DD-MM-YYYY HH:mm';
  const { t } = useTranslation();
  return [
    {
      keyTitle: 'vesting.card_data.total_bkn_purchased',
      children: <AmountDisplay text={vestingInfo?.totalPurchased} />,
      helperText: t(
        'vesting.card_data.data_box.total_bkn_purchased.helper_text'
      )
    },
    {
      keyTitle: 'vesting.card_data.total_bkn_claimed',
      children: (
        <AmountDisplay
          text={vestingInfo?.totalClaimed}
          minDecimals={4}
          maxDecimals={5}
        />
      ),
      helperText: t('vesting.card_data.data_box.total_bkn_claimed.helper_text')
    },
    {
      keyTitle: 'vesting.card_data.tge_initial_claim',
      children: <AmountDisplay text={vestingInfo?.tgeInitialClaim} />,
      subtitle: <AmountDisplay text={'%'} />,
      helperText: t('vesting.card_data.data_box.tge_initial_claim.helper_text')
    },
    {
      keyTitle: 'vesting.card_data.dripping_percent_per_day.text',
      children: <AmountDisplay text={vestingInfo?.drippingPercentPerDay} />,
      subtitle: (
        <AmountDisplay
          text={t('vesting.card_data.dripping_percent_per_day.value')}
        />
      ),
      helperText: t(
        'vesting.card_data.data_box.dripping_percent_per_day.helper_text'
      )
    },
    {
      keyTitle: 'vesting.card_data.start_date',
      helperText: t('vesting.card_data.data_box.start_date.helper_text'),
      children: vestingInfo?.startDate ? (
        <AmountDisplay
          text={dayjs(+vestingInfo?.startDate * 1000).format(dateFormat)}
        />
      ) : (
        <span>-</span>
      )
    },
    {
      keyTitle: 'vesting.card_data.initial_lockup_period',
      helperText: t(
        'vesting.card_data.data_box.initial_lockup_period.helper_text'
      ),
      children: vestingInfo?.initialLockupPeriod ? (
        <AmountDisplay
          text={dayjs(
            (+vestingInfo?.initialLockupPeriod + +vestingInfo?.startDate) * 1000
          ).format(dateFormat)}
        />
      ) : (
        <span>-</span>
      )
    },
    {
      keyTitle: 'vesting.card_data.day_to_receive_all_tokens',
      helperText: t(
        'vesting.card_data.data_box.day_to_receive_all_tokens.helper_text'
      ),
      children: vestingInfo?.vestingPeriod ? (
        <AmountDisplay
          text={dayjs(
            (+vestingInfo?.vestingPeriod + +vestingInfo?.startDate) * 1000
          ).format(dateFormat)}
        />
      ) : (
        <span>-</span>
      )
    }
  ];
};
